import React from 'react'
import PropTypes from 'prop-types'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, FormProvider } from 'react-hook-form'
import styled from '@emotion/styled'

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

import { config } from '../../config'
import { useMultiFieldValidation } from '../../hooks/useMultiFieldValidation'
import { requestorSchema } from '../../schemas/foiSchema'
import { emptyRequestor, getFoiStepperArray } from '../../util/foiConsts'
import {
  Form,
  DarkBGPaddedFormDiv,
  FormSectionDiv,
  FlexEndButtonErrorContainer,
  SpaceBetweenRowContainer,
  FlexEndContainer,
  FlexColumn
} from '../styles/Containers'
import Button from '../common/Button'
import BodyText from '../styles/Text'
import NameForm from '../foiForms/NameForm'
import ContactForm from '../foiForms/ContactForm'
import Carousel from '../common/Carousel'

const NavButtonContainer = styled(FlexEndContainer)`
  text-wrap: nowrap;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

function ContactInformationStep({ requestor = emptyRequestor, onComplete = () => {} }) {
  const methods = useForm({
    mode: 'all',
    resolver: yupResolver(requestorSchema),
    defaultValues: { ...requestor }
  })
  const { handleSubmit } = methods
  useMultiFieldValidation(methods, ['requestor.email', 'requestor.address'])
  useMultiFieldValidation(methods, ['requestor.address'], ['requestor.city', 'requestor.province', 'requestor.postalCode'])
  useMultiFieldValidation(methods, ['requestor.email', 'requestor.confirmEmail'], ['requestor.confirmEmail'])

  const onError = (errors, e) => console.error('Error', errors, e)

  function onSubmit(data) {
    const contactData = structuredClone(data)
    if (!contactData.requestor.isBusiness) contactData.requestor.businessName = ''
    onComplete(contactData)
  }

  return (
    <FlexColumn>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit, onError)} gap="30px">
          <SpaceBetweenRowContainer gap="50px">
            <Carousel steps={getFoiStepperArray(config.foi.APPLICATION_FEE)} activeStep={0} />
            <NavButtonContainer>
              <Button padding="large" type="submit">
                Request
                <ArrowForwardIosIcon />
              </Button>
            </NavButtonContainer>
          </SpaceBetweenRowContainer>
          <DarkBGPaddedFormDiv>
            <FormSectionDiv>
              <NameForm />
            </FormSectionDiv>
            <FormSectionDiv>
              <ContactForm />
            </FormSectionDiv>
            <FlexEndButtonErrorContainer>
              <Button padding="large" type="submit">
                Request
                <ArrowForwardIosIcon />
              </Button>
            </FlexEndButtonErrorContainer>
            <BodyText>{config.foi.request.disclaimer}</BodyText>
          </DarkBGPaddedFormDiv>
        </Form>
      </FormProvider>
    </FlexColumn>
  )
}

ContactInformationStep.propTypes = {
  requestor: PropTypes.object,
  onComplete: PropTypes.func
}

export default ContactInformationStep
